import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import Home from "./components/home";
import Login from "./components/login";

const App = () => {
    return(
        <Router>
            <Switch>
                <Route exact path="/" component = {Home} />
                <Route exact path="/update-data" component = {Login} />
            </Switch>
        </Router>
    );
};

export default App;